import React from "react";
import {
  Routes,
  Route,
  Link,
  Navigate,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Cookies from 'js-cookie';
import { Main, PlayerContainer } from "player-components";
import {
  MusicNoteIcon,
  FireIcon,
  AdjustmentsIcon,
  CollectionIcon,
  QuestionMarkCircleIcon,
  CogIcon
} from "@heroicons/react/solid";
import { useSelector, useDispatch } from "react-redux";
import {
  selectStatus,
  selectSections,
  selectTitle,
  selectArtist,
  selectSession,
  selectDuration,
  selectPitch,
  selectSpeed,
  changeGlobalPlaybackRate,
  decreaseGlobalPlaybackRate,
  increaseGlobalPlaybackRate,
  changeGlobalPitch,
  decreaseGlobalPitchRate,
  increaseGlobalPitchRate,
  setIsLooping,
  playSong,
  pauseSong,
  stopSong,
  recordSong,
  toggleMasterMute,
  selectPlaybackState,
  selectIsLooping,
  selectLoopStart,
  selectLoopEnd,
  selectIsMasterMuted,
  packSessionAsync,
  mountSessionAndRenderOfflineAsync,
  resetSessionMixerSettings,
  seek,
  unmountSessionAsync,
} from "../../features/session/sessionSlice";

import { selectUser, setSubscribedAsync, logout, setAuth } from "../../features/auth/authSlice";

import {
  selectSidebarOpen,
  toggleSidebar,
  setNewTrackModalVisible,
  selectFeedbackModalVisible,
  setFeedbackModalVisible,
  selectiOSModalVisible,
  setIOSModalVisible,
  submitFeedback,
  selectClientConfig,
  selectShowLyrics,
  setShowLyrics,
  selectSoloMode,
  setSoloMode,
  selectShowDeveloperTools,
} from "../../features/ui/uiSlice";



// pgw 13-jan-2025
// 
// import Setlist from "../Setlist";
import Setlist from "../SetList";

import CreateSetlist from "../CreateSetlist";
import MySetlist from "../MySetlist";



// pgw 13-jan-2025
// 
// import Setlists from "../Setlists";
import Setlists from "../SetLists";

import Session from "../Session";
import Library from "../Library";
import Help from "../Help";
import Experiments from "../Experiments";
import NotFound from "../NotFound";
import audioEngine from "../../services/audioEngine";
import { useCallback } from "react";

import { useEffect } from "react";
import { useRef } from "react";

// pgw 25-jun-2025 - add offline logic
// import { useRef } from "react";


import FeedbackModal from "../../components/FeedbackModal";
import { useTour } from '@reactour/tour'

import IOSModal from "../../components/IOSModal";
import { selectLyricsLyrics } from "../../features/lyrics/lyricsSlice";
import Settings from "../Settings";

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';


// pgw 07-oct-2025
// connectivity probe you can call ad-hoc
async function isReallyOnline1(timeoutMs = 2000) {
	// console.log('isReallyOnline1 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	// console.log('isReallyOnline1 p2')
    return res.ok;
  } catch {
	// console.log('isReallyOnline1 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}

async function isReallyOnline2(timeoutMs = 2000) {
	// console.log('isReallyOnline2 p1')
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort('timeout'), timeoutMs);
  try {
    const res = await fetch('/_network-check?t=' + Date.now(), {
      cache: 'no-store',
      credentials: 'omit',
      signal: controller.signal
    });
	// console.log('isReallyOnline2 p2')
    return res.ok;
  } catch {
	// console.log('isReallyOnline2 p3')
    return false;
  } finally {
    clearTimeout(t);
  }
}



const Authenticated = ({ parentVersion, context, config }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setIsOpen } = useTour()

  const pitch = useSelector(selectPitch);
  const speed = useSelector(selectSpeed);
  const playbackState = useSelector(selectPlaybackState);
  const isLooping = useSelector(selectIsLooping);
  const loopStart = useSelector(selectLoopStart);
  const loopEnd = useSelector(selectLoopEnd);
  const duration = useSelector(selectDuration);
  const sections = useSelector(selectSections);
  const isMasterMuted = useSelector(selectIsMasterMuted);
  const title = useSelector(selectTitle);
  const artist = useSelector(selectArtist);
  const currentUser = useSelector(selectUser);
  const sidebarOpen = useSelector(selectSidebarOpen);
  const currentPositionInterval = useRef(null);
  const status = useSelector(selectStatus);
  const session = useSelector(selectSession);
  const feedbackModalVisible = useSelector(selectFeedbackModalVisible);
  const iOSModalVisible = useSelector(selectiOSModalVisible);
  const clientConfiguration = useSelector(selectClientConfig);
  const showLyrics = useSelector(selectShowLyrics);
  const songLyricsLyrics = useSelector(selectLyricsLyrics);
  const soloMode = useSelector(selectSoloMode);
  const showDeveloperTools = useSelector(selectShowDeveloperTools);


/*
function handleLogoClick(e) {
  e.preventDefault(); // stop default link navigation

  if (shouldNavigateToExternalSite()) {
    window.location.href = clientConfiguration.images.menuLogoLink;
  } else {
    // for example, open an in-app menu or route internally
    // console.log('Decided not to navigate externally');
    // e.g. navigate('/home') if using react-router
  }
}

function shouldNavigateToExternalSite() {
  // Your decision logic here
  // Example: skip external link when offline or VPN suspected
  return navigator.onLine && !window.__CONNECTIVITY_STATUS__?.suspect;
}
*/

function logoNav() {
	// console.log('logoNav p1, clientConfiguration.images.menuLogoLink = ', clientConfiguration.images.menuLogoLink)
  // This preserves existing behaviour
  window.location.href = clientConfiguration.images.menuLogoLink;
	// console.log('logoNav p2')
}


  const handleLogoLinkTest = async (e) => {
		// console.log('handleLogoLinkTest p1, e = ', e)
	e.preventDefault(); // stop default link navigation

	// pgw 07-oct-2025
	const ok = await isReallyOnline1(2500);
		// console.log('handleLogoLinkTest p2, ok = ', ok)
	if (ok) {
		debugLog('user is online')
	}
	else {
		debugLog('user is offline !!')

		let confStr = "You are offline !"
		confStr = confStr + "\n" + "It is not possible to go to the Choir Player web site while you are offline."
		confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
		confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"

		let res = confirm(confStr)
		if (res) {
			debugLog("You pressed OK!");
		} else {
			debugLog("You pressed Cancel - returning...");
			return;
		}

	}
		// console.log('handleLogoLinkTest p3 before navigate')

	navigate(`${clientConfiguration.images.menuLogoLink}`);

		// console.log('handleLogoLinkTest p4 after navigate')

    // window.location.href = clientConfiguration.images.menuLogoLink;

  }




  const handleLoginLogout = async () => {

	debugLog("pgw handleLoginLogout p21")



	// pgw 07-oct-2025
	const ok = await isReallyOnline2(2500);
	if (ok) {
		debugLog('user is online')
	}
	else {
		debugLog('user is offline !!')

		let confStr = "You are offline !"
		confStr = confStr + "\n" + "It is not possible to login or logout while you are offline."
		confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
		confStr = confStr + "\n" + "(OK to continue; Cancel to do nothing)"

		let res = confirm(confStr)
		if (res) {
			debugLog("You pressed OK!");
		} else {
			debugLog("You pressed Cancel - returning...");
			return;
		}

	}




	// pgw 24-may-2024 testing
	debugLog("pgw handleLoginLogout clientConfiguration.features.auth.mode = ", clientConfiguration.features.auth.mode)
    if (clientConfiguration.features.auth.mode === "domainCookie") {
      const session_id = Cookies.get(clientConfiguration.features.auth.domainCookie.cookieId);

	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.cookieId = ", clientConfiguration.features.auth.domainCookie.cookieId)
	  debugLog("pgw handleLoginLogout session_id = ", session_id)
	  debugLog("pgw handleLoginLogout currentUser = ", currentUser)
	  debugLog("pgw handleLoginLogout currentUser?.guest = ", currentUser?.guest)
	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.logoutUrl = ", clientConfiguration.features.auth.domainCookie.logoutUrl)
	  debugLog("pgw handleLoginLogout clientConfiguration.features.auth.domainCookie.loginUrl = ", clientConfiguration.features.auth.domainCookie.loginUrl)

	  // pgw 04-jun-2024
	  // Fix bug where logout request is never made because browser caches it

      if (!currentUser?.guest) {
	    debugLog("pgw handleLoginLogout p2")
		var newlocNoCache = clientConfiguration.features.auth.domainCookie.logoutUrl + "?c=" + (new Date()).valueOf();
	    debugLog("pgw handleLoginLogout p2a newlocNoCache = ", newlocNoCache)
        window.location.href = newlocNoCache
        // window.location.href = clientConfiguration.features.auth.domainCookie.logoutUrl;
      } else {
	    debugLog("pgw handleLoginLogout p3")
        if (session_id) {
	      debugLog("pgw handleLoginLogout p4")
          dispatch(setSubscribedAsync(session_id));
        } else {
	      debugLog("pgw handleLoginLogout p5")
          window.location.href = clientConfiguration.features.auth.domainCookie.loginUrl;
        }
      }
    }
	debugLog("pgw handleLoginLogout p6")
    dispatch(unmountSessionAsync());
  }

  const handleToggleSidebar = () => {
    dispatch(toggleSidebar(!sidebarOpen));
  };

  // redirect users to library if no login required
  useEffect(() => {
    if (clientConfiguration.features.auth.mode === "domainCookie") {
      if (location.pathname === "/") {
        navigate("/library");
      }
    }
  }, [location, navigate, clientConfiguration.features.auth.mode]);

  useEffect(() => {
    currentPositionInterval.current = 0;
  }, []);

  const shareSession = async () => {
    await dispatch(packSessionAsync());
  };

  const downloadSession = async () => {
    await dispatch(
      mountSessionAndRenderOfflineAsync({
        cache: clientConfiguration.features.session.cacheOnMount,
      })
    );
  };

  const resetSession = async () => {
    await dispatch(resetSessionMixerSettings());
  };

  const MenuLink = ({ to, label, icon, active, newWindow = false }) => {
    return (
      <Link
        target={newWindow?'_blank': ''}
        className={`text-white ${
          active ? "bg-primary  hover:text-white" : ""
        } hover:text-primary group flex items-center px-2 py-2 text-sm font-medium rounded-md`}
        to={to}
        onClick={() => dispatch(toggleSidebar(false))}
      >
        {icon}
        <span className="ml-1 text-white">{label}</span>
      </Link>
    );
  };

  const VersionNumber = ({ children }) => {
    return (
      <div className={`mt-4 text-white px-2 py-2 text-sm font-medium`}>
        <small>
        {children}</small>
      </div>
    );
  };

  const handleSelectSection = (section) => {};

  const handleUpdatePosition = (position) => {

	// pgw 03-apr-2025 - testing - trying to get playback to restart if user clicks on timeline when looping is enabled....
	// Didn't work, so revent to original logic...

// 	debugLog("pgw pgw handleUpdatePosition position = ", position)
// 	debugLog("pgw pgw handleUpdatePosition isLooping = ", isLooping)

	dispatch(playSong());
	dispatch(seek(position * 1000));

	// This didn't work...
	/*
	if (isLooping) {
		dispatch(seek(position * 1000));
		dispatch(playSong());
	}
	else {
		dispatch(playSong());
		dispatch(seek(position * 1000));
	}
	*/


  };

  const handleOnLoop = () => {
    let startMs = null;
    let endMs = null;

	debugLog("pgw pgw handleOnLoop isLooping = ", isLooping)

    if (!isLooping) {
      const currentPosition = audioEngine.currentPosition / 1000;

		debugLog("pgw pgw handleOnLoop currentPosition = ", currentPosition)

      if (sections?.length) {
        for (const section of sections) {
          if (
            currentPosition >= section.start &&
            currentPosition < section.end
          ) {
            startMs = section.start * 1000;
            endMs = section.end * 1000;
          }
        }
      }
    }
    dispatch(setIsLooping({ startMs, endMs }));
  };

  const handleFeedbackModalClose = () => {
    dispatch(setFeedbackModalVisible(false));
  };

  const handleFeedbackModalSubmit = (feedback) => {
    dispatch(submitFeedback(feedback));
    dispatch(setFeedbackModalVisible(false));
  };

  const handleIOSModalClose = (feedback) => {
    dispatch(setIOSModalVisible(false));
  };

  const handleSoloModeToggle = () => {
    setIsOpen(false);
    if (soloMode) {
      dispatch(setSoloMode(false));
    } else {
      dispatch(setSoloMode(true));
    }
  }

  const handleMixReset = () => {
// pgw 21-apr-2023
//     debugLog('show tourguide');
//     setIsOpen(true);
    dispatch(setSoloMode(false));
    //set all track volume to  1;
    dispatch(resetSessionMixerSettings());

  }

  const getShouldShowPitchSpeedControls = () => {
    return true;
  };

  const getRouteTitle = () => {
    switch (location.pathname) {
      case "/session":
        return session.status === "ready" ? title : "Session";
      case "/setlist/create":
        return "Create setlist";
      case "/setlists":
        return "Setlists";
      case "/library":
        return "Song library";
      case "/settings":
          return "Settings";
      case "/help":
        return "Help";
      case "/experiments":
        return "Experiments";
      default:
        if (location.pathname.includes("/setlist/")) return "Setlist";
        return "";
    }
  };

  const formNavigationItems = () => {
    let navItems = [];

    navItems.push({
      element: (
        <MenuLink
          to="/session"
          label="Session"
          icon={<AdjustmentsIcon className="h-6 w-6'" />}
          active={location.pathname === "/session"}
        />
      ),
    });

    if (clientConfiguration.features.setlist.enabled) {
      navItems.push({
        element: (
          <MenuLink
            to="/my-setlist"
            label={clientConfiguration.labels.setlist}
            icon={<CollectionIcon className="h-6 w-6'" />}
            active={location.pathname === "/my-setlist"}
          />
        ),
      });
    }

    navItems.push({
      element: (
        <MenuLink
          to="/library"
          label={clientConfiguration.labels.library}
          icon={<MusicNoteIcon className="h-6 w-6'" />}
          active={location.pathname === "/library"}
        />
      ),
    });

    if (clientConfiguration.features.setlists.enabled) {
      navItems.push({
        element: (
          <MenuLink
            to="/setlists"
            label={clientConfiguration.labels.setlists}
            icon={<CollectionIcon className="h-6 w-6'" />}
            active={
              location.pathname === "/setlists" ||
              location.pathname.includes("/setlist/")
            }
          />
        ),
      });
    }

    navItems.push({
      element: (
        <MenuLink
          // newWindow={location.pathname !== '/help' ? true: false}
          to="/help"
          label="Help"
          icon={<QuestionMarkCircleIcon className="h-6 w-6'" />}
          active={location.pathname === "/help"}
        />
      ),
    });
    navItems.push({
      element: (
        <MenuLink
          to="/settings"
          label={<div id="ram-display">Settings</div>}
          icon={<CogIcon className="h-6 w-6'" />}
          active={location.pathname === "/settings"}
        />
      ),
    });

    if (showDeveloperTools) {
      navItems.push({
      element: (
        <MenuLink
          to="/settings"
          label={<div id="ram-display">{window.ramUsage.toUpperCase()} used</div>}
          icon={null}
          active={false}
        />
      )
    });
  }

    navItems.push({
      element: (
        <VersionNumber>v{parentVersion}</VersionNumber>
      )
    });

    return navItems;
  };


// pgw 07-oct-2025
/*

      logoLink={"#"}
      onLogoClick={handleLogoLinkTest}

      logoLink={`${clientConfiguration.images.menuLogoLink}`}


      logoLink={"#"}
      onLogoClick={handleLogoLinkTest}


*/


  return clientConfiguration ? (
    <Main
      logoUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.menuLogo}`}

      logoLink={`${clientConfiguration.images.menuLogoLink}`}


      backgroundUrl={`${process.env.PUBLIC_URL}${clientConfiguration.images.menuBackground}`}
      navigationItems={formNavigationItems()}
      user={currentUser}
      navigation={[]}
      loginLogoutLabel={
        !currentUser.guest
          ? clientConfiguration.features.auth[
              clientConfiguration.features.auth.mode
            ].logoutLabel
          : clientConfiguration.features.auth[
              clientConfiguration.features.auth.mode
            ].loginLabel
      }
      onLoginLogout={handleLoginLogout}
      headerContext={{
        currentSong: {
          title: getRouteTitle(),
          artist: artist,
        },
        onShare: shareSession,
        onAddStem: () => dispatch(setNewTrackModalVisible(true)),
        onDownload: downloadSession,
        onReset: resetSession,
        showExtraMenu: false,
        showActionButton:
          songLyricsLyrics &&
          location.pathname === "/session" &&
          status === "ready",
        actionButtonActive: showLyrics,
        onClickedActionButon: () => dispatch(setShowLyrics(!showLyrics)),
      }}
      sidebarOpen={sidebarOpen}
      onToggleSidebar={handleToggleSidebar}
    >
      <PlayerContainer
        showPitchSpeedControls={getShouldShowPitchSpeedControls()}
        showMixRecord={clientConfiguration.features.session.showMixRecord}
        pitch={pitch}
        speed={speed}
        onChangeSpeed={(v) => dispatch(changeGlobalPlaybackRate(v))}
        onSpeedMinus={() => dispatch(decreaseGlobalPlaybackRate())}
        onSpeedPlus={() => dispatch(increaseGlobalPlaybackRate())}
        onChangePitch={(v) => dispatch(changeGlobalPitch(v))}
        onPitchMinus={() => dispatch(decreaseGlobalPitchRate())}
        onPitchPlus={() => dispatch(increaseGlobalPitchRate())}
        getCurrentPosition={() => audioEngine.currentPosition / 1000}
        onChangePosition={handleUpdatePosition}
        onSelectSection={handleSelectSection}
        onSoloModeToggle={handleSoloModeToggle}
        soloMode={soloMode}
        onReset={handleMixReset}
        onMute={(v) => dispatch(toggleMasterMute())}
        song={{
          title: title,
          artist: artist,
          length: duration,
          sections: sections,
        }}
        onPlayPause={() => {
          if (playbackState === "playing") {
            dispatch(pauseSong());
          } else {
            dispatch(playSong());
          }
        }}
        onStop={() => dispatch(stopSong())}
        onRecord={() => dispatch(recordSong())}
        onLoop={handleOnLoop}
        isRecording={playbackState === "recording"}
        isPlaying={playbackState === "recording" || playbackState === "playing"}
        isMuted={isMasterMuted}
        isLooping={isLooping}
        loopStart={loopStart/1000}
        loopEnd={loopEnd/1000}
        showTransportControls={
          location.pathname === "/session" && status === "ready"
        }
      >
        <Routes>
          <Route path={`/session`} element={<Session />} />
          {clientConfiguration.features.setlist.enabled && (
            <Route path={`/my-setlist`} element={<MySetlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlist/:id`} element={<Setlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlist/create`} element={<CreateSetlist />} />
          )}
          {clientConfiguration.features.setlists.enabled && (
            <Route path={`/setlists`} element={<Setlists />} />
          )}
          <Route path={`/library`} element={<Library />} />
          <Route path={`/help`} element={<Help />} />
          <Route path={`/settings`} element={<Settings />} />
          <Route path={`/experiments`} element={<Experiments />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </PlayerContainer>
      {feedbackModalVisible && (
        <FeedbackModal
          onClose={handleFeedbackModalClose}
          onSubmit={handleFeedbackModalSubmit}
        />
      )}
      {iOSModalVisible && <IOSModal onClose={handleIOSModalClose} />}
    </Main>
  ) : (
    <Navigate to="/" />
  );
};

export default Authenticated;
